/**
 * @module api-scm:costCenter:logisticsCostAnalyse
 */
import service from '@/service'

/**
 * @description: 导入物流成本数据分析
 */

export function importLogisticsCostDataAnalysis(data) {
  return service['api-scm']({
    url: '/public/logistics/importLogisticsCostDataAnalysis',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * @description: 下载物流成本数据分析
 */

export function downloadLogisticsCostDataAnalysis(data) {
  return service['api-scm']({
    url: '/public/logistics/downloadLogisticsCostDataAnalysis',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
